import React, { useEffect, useRef, useReducer, useState, useContext, useMemo } from 'react';

import { ContenedorParametros } from '../../components/utils/ContenedorParametros';
import { Tooltip } from '../../components/utils/Tooltip';
import { agregarDias, copiarTexto, formatDate, formatearFechaHora, notify, obtenerEstado, obtenerHoraActual, pintarFila, primeraLetraMayuscula, primeraLetraMayusculaOracion, transformarArchivoUrl, validarExtensionImagen } from '../../../utils/utils';
import { BotonNuevo } from '../../components/buttons/BotonNuevo';
import { ModalProyecto } from '../../components/modal/ModalProyecto';
import { DatePickerABX } from '../../components/pickers/DatePicker';
import { useUsuarios } from '../../../hooks/usuarios/useUsuarios';
import { useModal } from '../../../hooks/useModal';
import { Modal } from '../../components/modal/Modal';
import { useProyectos } from '../../../hooks/proyectos/useProyectos';
import { useEmpresas } from '../../../hooks/useEmpresas';
import { useGeneral } from '../../../hooks/useGeneral';
import { MultiSelect } from '../../components/forms/MultiSelect';
import { useEntregables } from '../../../hooks/entregables/useEntregables';
import { useActividades } from '../../../hooks/actividades/useActividades';
import { NuevoSelectAutocomplete } from '../../components/forms/NuevoSelectAutocomplete';
import { Filtro } from '../../components/Filtro';
import { UserContext } from '../../../context/provider/UserProvider';
import { FasesProyecto } from '../../components/FasesProyecto';
import { LineaCarga } from '../../components/LineaCarga';
import { useNotificaciones } from '../../../hooks/useNotificaciones/useNotificaciones';
import { DetalleProyecto } from '../../components/DetalleProyecto';
import { ContenedorImagen } from '../../components/ContenedorImagen';
import { ContenedorDocumento } from '../../components/ContenedorDocumento';
import { MultiSelectorFecha } from '../../components/pickers/MultiSelectorFecha';
import { BotonProcesar } from '../../components/buttons/BotonProcesar';
import { useSeguimientos } from '../../../hooks/seguimientos/useSeguimientos';
import { PaginacionABEXA } from '../../components/PaginacionABEXA';
import { ProgressBarProject } from '../../components/ProgressBarProject';
import { ContenedorTabla } from '../../components/utils/ContenedorTabla';
import { SwitchToggle } from '../../components/SwitchToggle';
import { ExportExcel } from '../../components/utils/ExportExcel';

const imagenReducer = (estado, accion) => {
    switch(accion.tipo){
        case 'Agregar':
            return [...estado, ...accion.carga];
        case 'Remover':
            return estado.filter(file => file?.codigo ? 
                (file.codigo !== accion.carga.codigo) : (file.identificador !== accion.carga.identificador)
            );
        case 'Reiniciar':
            return []
        case 'Cargar':
            return accion.carga
        default:
            return estado;
    }
}

const docReducer = (estado, accion) => {
    switch(accion.tipo){
        case 'Agregar':
            return [...estado, ...accion.carga];
        case 'Remover':
            return estado.filter(file => file?.codigo ? 
                (file.codigo !== accion.carga.codigo) : (file.identificador !== accion.carga.identificador)
            );
        case 'Reiniciar':
            return []
        case 'Cargar':
            return accion.carga
        default:
            return estado;
    }
}

export const Proyectos = () => {
    const { stateUser } = useContext(UserContext);
    const [ startDate, setStartDate ] = useState(agregarDias(-30))
    const [ endDate, setEndDate ] = useState(formatDate(new Date()));
    const [ vistaProyecto, setVistaProyecto ] = useState(0)
    const [ isOpenModalEliminarEntregable, openModalEliminarEntregable, closeModalEliminarEntregable ] = useModal(null);
    const [ limpiarSelect, setLimpiarSelect ] = useState(false)
    const { empresas } = useEmpresas();
    const [ imagenes, envioImagen ] = useReducer(imagenReducer, []);
    const [ documentos, envioDoc ] = useReducer(docReducer, []);
    const [ tipoProyecto, setTipoProyecto ] = useState(0);
    const [ opcionesSeleccionadas, setOpcionesSeleccionadas ] = useState([])
    const [ ordenAscendente, setOrdenAscendente ] = useState(true);
    const [ verDetalleAnalisis, setVerDetalleAnalisis ] = useState(false);
    const [ despliegue, setDespliegue ] = useState(false);
    const [ vistaHistorial, setVistaHistorial ] = useState(false);
    const [ isOpenModalDetalleSeguimiento, openModalDetalleSeguimiento, closeModalDetalleSeguimiento ] = useModal(null);
    const [ dataConFiltros, setDataConFiltros ] = useState([]);
    const [ dataPaginada, setDataPaginada ] = useState([]);
    const [ esCrearSeguimiento, setEsCrearSeguimiento ] = useState(false);
    const [ valoresSeguimiento, setValoresSeguimiento ] = useState({indice: 0, codTicket: 0})
    const [ analisisImagen, setAnalisisImagen ] = useState([]);
    const [ analisisDoc, setAnalisisDoc ] = useState([]);

    const classNameInput = "containerScroll caret-white lg:text-xs border-zinc-600 border text-white rounded w-full bg-zinc-900 focus:outline-none focus:ring-1 focus:ring-blue-500";
    const classNameSelect = "rounded bg-zinc-900 focus:outline-none focus:ring-1 focus:ring-blue-500 h-[30px] ";
    const idTablaProyecto = "tabla-proyecto";
    const tablaProyectoRef = useRef(null);
    const [ isOpenModalImagen, openModalImagen, closeModalImagen ] = useModal(null)

    const {
        tiposTickets,
        prioridades,
        listarPrioridades,
        listarTiposTickets,
    } = useGeneral()

    const {
        usuarios,
        areas,
        listarUsuarios,
        listarUsuariosEmpresa,
        usuariosEmpresas,
        listarUsuarioTicketProyecto,
        usuariosProyecto,
        listarUsuarioTicketEntregable,
        usuariosEntregable
    } = useUsuarios()

    const {
        listarProyectos,
        proyectos,
        obtenerIdeaProyecto,
        idea,
        editarValorIdeaProyecto,
        registrarIdeaProyecto,
        obtenerDetalleInicioProyecto,
        inicio,
        registrarInicioProyecto,
        registrarInicioAutomatizado,
        editarValorInicioProyecto,
        analisis,
        listaAnalisis,
        obtenerAnalisisProyecto,
        registrarAnalisisProyecto,
        editarValorAnalisisProyecto,
        isOpenModalProyecto,
        closeModalProyecto,
        listarEntregableActividadPorTicket,
        entregableActividades,
        loading,
        openModalProyecto,
        finalizarProyecto,
        editarValorFinalizarProyecto,
        finProyecto,
        listarFinalizarProyecto,
        setLoading,
        eliminarAnalisisProyecto,
        rechazarTicket,
    } = useProyectos()

    const {
        entregable,
        guardarEntregable,
        editarValorEntregable,
        isOpenModalEntregable,
        openModalEntregable,
        closeModalEntregable,
        obtenerDetalleEntregable,
        eliminarEntregable,

    } = useEntregables()

    const {
        actividades,
        listarActividad,
        actividad,
        editarValorActividad,
        guardarEditarActividad,
        isOpenModalActividad,
        openModalActividad,
        closeModalActividad,
        obtenerActividadDetalle,
        actividadesPorTicket,
        listarActividadesPorTicket,
        eliminarActividad,
        regularizarActividad
    } = useActividades()

    const {
        obtenerToken,
        notificacionPorArea
    } = useNotificaciones()

    const {
        seguimientosTicket,
        listarSeguimientoTicket,
        nuevoSeguimientoTicket,
        editarValorNuevoSeguimiento,
        registrarSeguimientoPorTicket,
        editarValorSeguimiento,
        eliminarSeguimiento
    } = useSeguimientos()

    {/*CONVERTIR DATOS PARA SELECT CON BUSCADOR */}
    const usuariosConvertidos = usuarios.map(option => ({
        value: option.codUsuario,
        label: option.nomUsuario
    }));

    const usuariosEmpresaConvertidos = usuariosEmpresas?.map(option => ({
        value: option.codUsuario,
        label: option.nomUsuario
    }))

    const usuariosProyectoConvertidos = usuariosProyecto?.map(option => ({
        value: option.codUsuario,
        label: option.nomUsuario
    }))

    const usuariosEntregableConvertidos = usuariosEntregable?.map(option => ({
        value: option.codUsuario,
        label: option.nomUsuario
    }))

    const empresasConvertidas = empresas.map(option => ({
        value: option.codEmpresa,
        label: option.nomEmpresa
    }))

    // const obtenerEstado = (codigo,nombre) => {
    //     let labelEstado = '' ;
    //     switch(codigo){
    //         case 9:
    //             labelEstado = 'bg-yellow-500'
    //             break;
    //         case 48:
    //             labelEstado = 'bg-green-500'
    //             break;
    //         case 51:
    //             labelEstado = 'bg-red-500'
    //             break;
    //         case 60:
    //             labelEstado = 'bg-blue-500'
    //             break;
    //         case 35:
    //             labelEstado = 'bg-[#ED9324]'
    //             break;
    //         default:
    //             labelEstado ='bg-cyan-500'
    //             break;
    //     }
    //     return <span className={`${labelEstado} w-[70px] rounded px-2 text-xs whitespace-nowrap`}>{primeraLetraMayuscula(nombre)}</span>
    // }

    const obtenerEstadoActividad = (codEstado) => {
        let nombreEstado = ''
        let color = ''
        switch(codEstado){
            case 9: //Pendiente
                nombreEstado = 'Pendiente'
                color = ' bg-yellow-500 '
                break;
            case 48: //En proceso
                nombreEstado = 'En proceso'
                color = ' bg-green-500 '
                break;
            case 51: //Finalizado
                nombreEstado = 'Finalizado'
                color = ' bg-red-500 '
                break;
            default:
                nombreEstado = 'Pausa'
                color = ' bg-cyan-500 '
            break
        }
        
        return <p className={`${color} w-[80px] text-center rounded px-2 text-xs py-1`}>{primeraLetraMayuscula(nombreEstado)}</p>
    }

    const barraProgresoPorFechas = (fechaInicio, fechaFin, codEstado) => {
        if(!fechaInicio || !fechaFin)
        {
            return
        }
        const [ diaInicio, mesInicio, anioInicio ] = fechaInicio.split(' ')[0].split('/');
        const [ diaFin, mesFin, anioFin ] = fechaFin.split(' ')[0].split('/');
        const startDate = new Date(anioInicio, mesInicio - 1, diaInicio);
        const endDate = new Date(anioFin, mesFin - 1, diaFin);
        const today = new Date();
        const tiempoTotal = Number(endDate - startDate);
        const tiempoTranscurrido = Number(today - startDate);
        const diasTranscurrido = Math.floor(tiempoTranscurrido / (1000 * 60 * 60 * 24))
        const diasContabilizado = Math.floor(tiempoTotal / (1000 * 60 * 60 * 24))
        const porcentaje = Math.round((tiempoTranscurrido / tiempoTotal) * 100);
        let color = 'red'
        if(porcentaje <= 25){
            color = '#28a745'
        }
        else if(porcentaje <= 50){
            color = '#ffc107'
        }
        else if(porcentaje <= 75){
            color = '#fd7e14'
        }
        else{
            color = '#dc3545'
        }

        if(codEstado === 51){
            color = '#007bff'
        }
        return (
            <> 
                <label>{codEstado === 51 ? diasContabilizado : diasTranscurrido}</label>
                <ProgressBarProject color={color} porcentaje={porcentaje > 100 ? 100 : porcentaje} />
            </>
        )
    }

    {/*  GUARDAR REGISTROS DE EDT  */}
    const registrarEntregable = async () => {
        const isValid = await guardarEntregable(entregableActividades.codTicket);
        if(isValid){
            closeModalEntregable();
            listarEntregableActividadPorTicket(inicio.codTicket)
            listarProyectos(tipoProyecto, startDate, endDate)
        }
    }

    const registrarActividad = async () => {
        const isValid = await guardarEditarActividad();
        if(isValid){
            closeModalActividad();
            listarEntregableActividadPorTicket(inicio.codTicket);
        }
    }

    {/* ELIMINAR REGISTRO DE EDT */}
    const registrarEliminarActividad = async () => {
        const isValid = await eliminarActividad();
        if(isValid){
            closeModalEliminarEntregable();
            listarEntregableActividadPorTicket(inicio.codTicket);
        }
    }

    const registrarEliminarEntregable = async (codTicketEntregable) => {
        const isValid = await eliminarEntregable(codTicketEntregable);
        if(isValid){
            closeModalEliminarEntregable();
            listarEntregableActividadPorTicket(inicio.codTicket);
        }
    }

    {/* REGISTRO DE PROCESO DEL PROYECTO */}
    const registrarIdea = async () => {
        const urlImagen = imagenes.length > 0 && idea.parametrosImagen.length === 0 ? await transformarArchivoUrl(imagenes) : idea.parametrosImagen
        const urlDocumento = imagenes.length > 0 && idea.parametrosArchivo.length === 0 ? await transformarArchivoUrl(documentos) : idea.parametrosArchivo
        const response = await registrarIdeaProyecto(urlImagen, urlDocumento);
        if(response.isValid){
            await listarProyectos(tipoProyecto, startDate, endDate)
            closeModalProyecto()
        }
    }

    const esNuevoArchivo = (item) => item instanceof File || (item.constructor && item.constructor.name === 'File') 
    
    const registrarProyecto = async () => {
        let urlImagen = [];
        let urlDocumento = [];
        // const camposAValidar = ["codAreaDestino","codUsuarioResponsable","codUsuarioParticipanteConcatenado","fechaInicioProgramadoTicket",
        const camposAValidar = ["codAreaDestino","codUsuarioResponsable","fechaInicioProgramadoTicket",
            "horaInicioProgramadoTicket","fechaFinProgramadoTicket","horaFinProgramadoTicket","codEmpresa",
            "codUsuarioSolicitante","codTicketTipo","codPrioridad"
        ];

        const validarDetalleIngresado = camposAValidar.some(campo => inicio[campo] === "" || inicio[campo] === null || inicio[campo] === 0 || inicio[campo] === undefined);
        if(validarDetalleIngresado){
                !despliegue &&  setDespliegue(true)
                notify("Falta completar datos del formulario", "warning");
                return
            }
        {/*Aca debe ir la correccion de la imagenes edicion */}
        if(imagenes.length > 0){
            if(inicio.parametrosImagen.length === 0){
                urlImagen = await transformarArchivoUrl(imagenes) ;
            }
            else{
                const nuevasImagenes = imagenes.filter(img => esNuevoArchivo(img));
                const imagenesBD = inicio.parametrosImagen.filter(img =>  imagenes.some(imagen => imagen.codigo === img.codTicketArchivo));
                const imagenesNuevas = await transformarArchivoUrl(nuevasImagenes);
                urlImagen = [ ...imagenesBD, ...imagenesNuevas ];
            }
        }

        if(documentos.length > 0){
            if(inicio.parametrosArchivo.length === 0){
                urlDocumento = await transformarArchivoUrl(documentos);
            }
            else{
                const nuevosDocumentos = documentos.filter(doc => esNuevoArchivo(doc));
                const documentosBD = inicio.parametrosArchivo.filter(doc => documentos.some(documento => documento.codigo === doc.codTicketArchivo));
                const documentosNuevos = await transformarArchivoUrl(nuevosDocumentos);
                urlDocumento = [ ...documentosBD, ...documentosNuevos ];
            }
        }

        const isValid = inicio.automatizarIncidencia ? await registrarInicioAutomatizado(urlImagen, urlDocumento) : await registrarInicioProyecto(urlImagen, urlDocumento)
        if(isValid){
            await obtenerDetalleInicioProyecto(inicio.codTicket)
            await listarProyectos(tipoProyecto, startDate, endDate)
        }
    }

    const registrarAnalisis = async () => {
        const urlImagen = imagenes.length > 0 ? await transformarArchivoUrl(imagenes) : [];
        const urlDocumento = documentos.length > 0 ? await transformarArchivoUrl(documentos) : [];
        const isValid = await registrarAnalisisProyecto(urlImagen, urlDocumento);
        if(isValid){
            editarValorAnalisisProyecto('codUsuarioParticipanteConcatenado','')
            editarValorAnalisisProyecto('fechaInicioAnalisis',formatDate(new Date))
            editarValorAnalisisProyecto('horaInicioAnalisis',obtenerHoraActual())
            editarValorAnalisisProyecto('fechaFinAnalisis',formatDate(new Date))
            editarValorAnalisisProyecto('horaFinAnalisis',obtenerHoraActual())
            editarValorAnalisisProyecto('titulo','')
            editarValorAnalisisProyecto('descripcionAnalisis','')
            envioImagen({ tipo: 'Reiniciar' })
            envioDoc({ tipo: 'Reiniciar' })
            await obtenerAnalisisProyecto(inicio.codTicket)
        }
    }

    const guardarSegunVista = () => {
        switch(vistaProyecto){
            case 1: registrarIdea()
                break;
            case 2: registrarProyecto()
                break;
            case 3:registrarAnalisis()
                break;
            case 4:console.log(' guardando vista -> ',vistaProyecto)
                break;
            case 5:console.log(' guardando vista -> ',vistaProyecto)
                break;
            case 6: registrarFinProyecto()
                break;
            case 7: registrarRechazoProyecto()
                break;
            default:
                break;
        }
    }

    const registrarFinProyecto = async () => {
        if(finProyecto.motivo === ''){
            notify('Debe ingresar un comentario de cierre', 'error');
            return
        }
        // const nomArea = areas.find( a => a.codArea ===  inicio.codAreaDestino).nomArea
        const urlImagen = imagenes.length > 0 ? await transformarArchivoUrl(imagenes) : [];
        const urlDocumento = documentos.length > 0 ? await transformarArchivoUrl(documentos) : [];
        const isValid = await finalizarProyecto(inicio.codTicket, urlImagen,urlDocumento);
        if(isValid){
            // const responseToken = await obtenerToken()
            // if(responseToken.isValid){
            //     const mensaje = `${inicio.nomTicket}| Incidencia finalizada`
            //     notificacionPorArea(responseToken.token,nomArea, mensaje, 'PGI')
            // }
            await listarProyectos(tipoProyecto, startDate, endDate)
            closeModalProyecto()
            // obtenerAnalisisProyecto(inicio.codTicket)
        }
    }

    const registrarRechazoProyecto = async () => {
        if(inicio.motivoRechazo === ''){
            notify('Debe ingresar un motivo de rechazo', 'error');
            return
        }

        const urlImagen = imagenes.length > 0 ? await transformarArchivoUrl(imagenes) : [];
        const isValid = await rechazarTicket(inicio.codTicket, inicio.motivoRechazo, urlImagen);
        if(isValid){
            await listarProyectos(tipoProyecto, startDate, endDate)
            closeModalProyecto()
        }
    }

    const registrarSeguimientoTicket = async (indice) => {
        const isValid = await registrarSeguimientoPorTicket(indice);
        if(isValid){
            editarValorNuevoSeguimiento('descripcion','')
            await listarSeguimientoTicket(valoresSeguimiento.codTicket)
            await listarProyectos(tipoProyecto, startDate, endDate)
        }
    }

    const actividadesAgrupadas = actividadesPorTicket?.reduce((acumulador, actividad) => {
        const { codTicketEntregable,nomEntregable } = actividad;
        const grupoExistente = acumulador.find(grupo => grupo.codTicketEntregable === codTicketEntregable)
        // const indiceTicket = acumulador.findIndex(item => item.codTicketEntregable === codTicketEntregable);

        if(!grupoExistente){
            acumulador.push({
                codTicketEntregable,
                nomEntregable,
                cantidadFilas: 1,
                actividades: [actividad]
            })
        }
        else{
            grupoExistente.actividades.push(actividad);
            grupoExistente.cantidadFilas++
        }
        return acumulador;
    }, []);

    {/* LOGICA PARA EL GUARDADO DE ARCHIVOS */}
    const parseURLArchivo = async (archivos) => {
        return archivos.map(option => {
            const nuevoObjeto = {};
            Object.keys(option).forEach(key => {
                if(key === 'codTicketArchivo'){
                    nuevoObjeto.codigo = option[key];
                }
                else
                    if(key.startsWith('nom')){
                        nuevoObjeto.nom = option[key];
                    }
                    else
                        if(key.startsWith('url')){
                            nuevoObjeto.url = option[key];
                        }
            });
            return nuevoObjeto;
        })
    }

    {/* ACTUALIZAR FECHA Y HORA INICIO DETALLE */}
    const asignarFechaActualInicio = async (fechaInicio, fechaFin) => {

        // FUNCION PARA AGREGAR UN MES - PARA PREDEFINIR LA FECHA FIN A UN MES
        const fecha = new Date();
        // fecha.setMonth(fecha.getMonth() + 2);
        
        if(fechaInicio === '' && fechaFin === ''){
            editarValorInicioProyecto('fechaInicioProgramadoTicket',formatDate(new Date()))
            editarValorInicioProyecto('horaInicioProgramadoTicket',obtenerHoraActual())
            // editarValorInicioProyecto('fechaFinProgramadoTicket',formatDate(new Date())) --Anterior
            editarValorInicioProyecto('horaFinProgramadoTicket', obtenerHoraActual(2))
            editarValorInicioProyecto('fechaFinProgramadoTicket', formatDate(fecha));

        }
    }

    {/* ACTUALIZAR FECHA Y HORA EDT */}
    const asignarFechaActualEntregable = () => {
        editarValorEntregable('fechaInicioProgramadoEntregable',formatDate(new Date()))
        editarValorEntregable('horaInicioProgramadoEntregable',obtenerHoraActual())
        editarValorEntregable('fechaFinProgramadoEntregable',formatDate(new Date()))
        editarValorEntregable('horaFinProgramadoEntregable', obtenerHoraActual())
    }

    const asignarFechaActualActividad = () => {
        editarValorActividad('fechaInicioProgramadoActividad',formatDate(new Date()))
        editarValorActividad('horaInicioProgramadoActividad',obtenerHoraActual())
        editarValorActividad('fechaFinProgramadoActividad',formatDate(new Date()))
        editarValorActividad('horaFinProgramadoActividad', obtenerHoraActual())
    }

    const cerrarModalProyecto = () => {
        closeModalProyecto()
        setVistaProyecto(0);
        envioImagen({tipo: 'Reiniciar'});
        setVistaHistorial(false);
        setDespliegue(false);
    }

    const registrarActividadRegularizada = async (codTicketActividad) => {
        const isValid = await regularizarActividad(codTicketActividad);
        if(isValid){
            listarEntregableActividadPorTicket(inicio.codTicket);
        }
    }

    {/* CARGA INICIAL */}
    useEffect(() => {
        (async ()=>{
            await listarPrioridades()
            await listarTiposTickets()
            await listarUsuarios(1)
            await listarUsuariosEmpresa(4)
        })()
    },[])

    useEffect(() => {
        if(vistaProyecto !== 0){
            switch(vistaProyecto){
                case 1:
                    const asincronaImg = async () => {
                        const urlImagen = await parseURLArchivo(idea.parametrosImagen);
                        envioImagen({ tipo: 'Cargar', carga: urlImagen});
                    }
                    const asincronaDoc = async () => {
                        const urlDocumento = await parseURLArchivo(idea.parametrosArchivo);
                        envioDoc({ tipo: 'Cargar', carga: urlDocumento});
                    }
                    idea.parametrosImagen.length > 0 ? asincronaImg() : envioImagen({tipo: 'Reiniciar'});
                    idea.parametrosArchivo.length > 0 ? asincronaDoc() : envioDoc({tipo: 'Reiniciar'});
                    break;
                case 2:
                    const asincronaImgInicio = async () => {
                        const urlImagen = await parseURLArchivo(inicio.parametrosImagen);
                        envioImagen({ tipo: 'Cargar', carga: urlImagen});
                    }
                    const asincronaDocInicio = async () => {
                        const urlDocumento = await parseURLArchivo(inicio.parametrosArchivo);
                        envioDoc({ tipo: 'Cargar', carga: urlDocumento});
                    }
                    inicio.parametrosImagen.length > 0 ? asincronaImgInicio() : envioImagen({tipo: 'Reiniciar'});
                    inicio.parametrosArchivo.length > 0 ? asincronaDocInicio() : envioDoc({tipo: 'Reiniciar'});
                    break;
                case 3:
                    obtenerAnalisisProyecto(inicio.codTicket);
                    listarUsuarios(0)
                    editarValorAnalisisProyecto('codTicket',inicio.codTicket);
                    editarValorAnalisisProyecto('fechaInicioAnalisis',formatDate(new Date))
                    editarValorAnalisisProyecto('horaInicioAnalisis',obtenerHoraActual())
                    editarValorAnalisisProyecto('fechaFinAnalisis',formatDate(new Date))
                    editarValorAnalisisProyecto('horaFinAnalisis',obtenerHoraActual())
                    break;
                case 4:
                    listarEntregableActividadPorTicket(inicio.codTicket)
                    break;
                case 5:
                    listarActividadesPorTicket(inicio.codTicket)
                    break;
                case 6:
                    (async () => {
                        inicio.codEstadoTicket === 51 && await listarFinalizarProyecto(inicio.codTicket)
                        const asincronaImgFin = async () => {
                            const urlImagen = await parseURLArchivo(finProyecto.parametrosImagen);
                            envioImagen({ tipo: 'Cargar', carga: urlImagen});
                        }
                        const asincronaDocFin = async () => {
                            const urlDocumento = await parseURLArchivo(finProyecto.parametrosArchivo);
                            envioDoc({ tipo: 'Cargar', carga: urlDocumento});
                        }
                        finProyecto.parametrosImagen.length > 0 ? asincronaImgFin() : envioImagen({tipo: 'Reiniciar'});
                        finProyecto.parametrosArchivo.length > 0 ? asincronaDocFin() : envioDoc({tipo: 'Reiniciar'});

                    })()
                    break;
                case 7:
                    const asincronaImgRechazar = async () => {
                        const urlImagen = await parseURLArchivo(inicio.parametrosImagenRechazo);
                        envioImagen({ tipo: 'Cargar', carga: urlImagen});
                    }

                    inicio.parametrosImagenRechazo.length > 0 ? asincronaImgRechazar() : envioImagen({tipo: 'Reiniciar'});
                    break
                default:
                    break;
            }

        }
        (vistaProyecto !== 3  && verDetalleAnalisis && setVerDetalleAnalisis(false) )
    },[vistaProyecto])

    useEffect(() => {
        setLoading(true)
        listarProyectos(tipoProyecto,startDate,endDate)
        setLoading(false)
    },[tipoProyecto,startDate,endDate])

    useEffect(()=> {
        !loading && setLoading(true)
        setDataConFiltros(
            proyectos
            .sort((a,b) => {
                if(a.fechaRegistro !== '' && b.fechaRegistro !== ''){
                    const fechaA = formatearFechaHora(a.fechaRegistro);
                    const fechaB = formatearFechaHora(b.fechaRegistro);
                    if (!fechaA && !fechaB) return 0;
                    if (!fechaA) return -1;
                    if (!fechaB) return -1;
                    return(ordenAscendente ? fechaB - fechaA : fechaA - fechaB)
                }
            })
            .filter(elemento => {
                const opcionesValidas = opcionesSeleccionadas.filter(opcion => opcion !== ''); // Filtrar opciones no vacías
                return opcionesValidas.length === 0 || // Si no hay opciones válidas, incluir todos
                    opcionesValidas.every(opcion => Object.values(elemento).includes(opcion)); 
            })
        )
        
    },[opcionesSeleccionadas,proyectos,ordenAscendente])

    useEffect(() => {
        if(tablaProyectoRef.current){
            setLoading(false);
        }
    },[dataConFiltros])

    useEffect(() => {
        if(vistaProyecto === 2){
            const asincronaImgInicio = async () => {
                const urlImagen = await parseURLArchivo(inicio.parametrosImagen);
                envioImagen({ tipo: 'Cargar', carga: urlImagen});
            }
            const asincronaDocInicio = async () => {
                const urlDocumento = await parseURLArchivo(inicio.parametrosArchivo);
                envioDoc({ tipo: 'Cargar', carga: urlDocumento});
            }
            inicio.parametrosImagen.length > 0 ? asincronaImgInicio() : envioImagen({tipo: 'Reiniciar'});
            inicio.parametrosArchivo.length > 0 ? asincronaDocInicio() : envioDoc({tipo: 'Reiniciar'});
        }
    },[inicio.parametrosImagen, inicio.parametrosArchivo])
    
    return (
        <>
            {loading && <LineaCarga/>}
            <ContenedorParametros titulo='Gestión de proyectos' tablaId={idTablaProyecto}>
                <MultiSelectorFecha
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    identificador='gestionProyecto'
                />
                <i className='fa fa-filter lg:hidden' data-tip={'tipoConsulta'} data-for={'tipoConsulta'}></i>
                <Tooltip id={'tipoConsulta'}>Tipo de consulta</Tooltip>
                <select className={`${classNameInput} h-[30px] lg:w-[80px] w-[140px]`} onChange={(e) =>setTipoProyecto(Number(e.target.value))}>
                    <option value={0}>-- Todos --</option>
                    {
                        tiposTickets.map( tipo => (
                            <option value={tipo.codTicketTipo} key={tipo.codTicketTipo}>{tipo.nomTicketTipo}</option>
                        ))
                    }
                </select>
                {
                    proyectos.length > 0 ?
                    <Filtro
                        nombreFiltros={['nomEstado','nomEmpresa','nomArea','nomPrioridad']}
                        seleccionDefault={['', '', proyectos.some(e => e.nomArea.toUpperCase() === stateUser.nomArea.toUpperCase()) ? stateUser.nomArea.toUpperCase() : '', '']}
                        data={proyectos}
                        setOpcionesSeleccionadas={setOpcionesSeleccionadas}
                    ></Filtro> : <></>
                }
                <BotonProcesar onClick={()=> listarProyectos(tipoProyecto,startDate,endDate)}></BotonProcesar>
                <BotonNuevo
                    onClick={async () => {
                        envioImagen({tipo: 'Reiniciar'})
                        envioDoc({tipo: 'Reiniciar'})
                        await obtenerDetalleInicioProyecto()
                        await obtenerIdeaProyecto()
                        setVistaProyecto(1)
                        openModalProyecto()
                    }}
                />
                <img src="https://img.icons8.com/?size=96&id=UECmBSgBOvPT&format=png" className="w-[40px] h-[40px] cursor-pointer" onClick={() => ExportExcel(["tablaOcultaProyectosTotales"],'Gestion de proyectos','Reporte de gestion de proyectos')}></img>
            </ContenedorParametros>
            <ContenedorTabla>
                <div
                    className=" containerScroll h-full lg:max-h-[80%]  contenedor-tabla w-auto"
                    key={'contenedorTabla'}
                >
                    <table
                        id={idTablaProyecto}
                        className="tableResponsive"
                        ref={tablaProyectoRef}
                    >
                        <thead>
                            <tr key={'trCabecera0'}>
                                <th className="w-[3%]">N°</th>
                                <th className="w-[4%]">TICKET</th>
                                <th className={`${tipoProyecto === 0 ? 'w-[19%]' : 'w-[23%]'} text-left"`}>NOMBRE DEL PROYECTO</th>
                                {
                                    tipoProyecto === 0 ? 
                                        <th className="w-[4%]">T.TICKET</th>
                                    : <></>
                                }
                                <th className="w-[10%]">EMPRESA</th>
                                <th className="w-[8%]">RESPONSABLE</th>
                                <th className="w-[8%]">U.CREACIÓN</th>
                                <th className="w-[9%]">F.REGISTRO</th>
                                <th className="w-[9%]">
                                    <span>F. ENTREGA</span>
                                    <i
                                        className={`fa ${ordenAscendente  ? 'fa-sort-amount-desc' : 'fa-sort-amount-asc'} pl-3`}
                                        data-tip={'ordenar'}
                                        data-for={'ordenar'}
                                        onClick={() => setOrdenAscendente(!ordenAscendente)}
                                    ></i>
                                    <Tooltip id={'ordenar'}>{`Orden por fecha ${ordenAscendente ? 'descendente' : 'ascendente'}`}</Tooltip>
                                </th>
                                <th className='w-[5%]'>DÍAS</th>
                                <th className='w-[18%]'>SEGUIMIENTO</th>
                                <th className="w-[6%]">ESTADO</th>
                                <th className="w-[5%]"></th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            dataConFiltros.length > 0 ?
                            dataConFiltros
                                .map((p, i) => {
                                    return (
                                        <tr key={p.codTicket} onClick={(e) => pintarFila(e.target)}>
                                            <td
                                                data-label="N:"
                                                className='text-center'
                                            >{++i}</td>
                                            <td
                                                data-label="TICKET:"
                                                className='text-center'
                                            >
                                                <span
                                                    className={`${p.registroPorPGI ? ' bg-red-500 ' : ' bg-blue-600 '} w-[50px] px-2 rounded`}
                                                >
                                                    {p.registroPorPGI ? p.codIncidencia : p.codTicket}
                                                </span>
                                            </td>
                                            <td
                                                data-label="NOMBRE:"
                                                className="w-[24%] lg:w-auto"
                                            >
                                                <div
                                                    className='lg:w-[200px] w-[400px] lg:text-right lg:px-2 whitespace-nowrap overflow-hidden text-ellipsis underline'
                                                    onClick={async () => {
                                                        await obtenerIdeaProyecto(p.codTicket)
                                                        await obtenerDetalleInicioProyecto(p.codTicket);
                                                        await asignarFechaActualInicio(p.fechaInicioProgramado||'', p.fechaFinProgramado||'')
                                                        setVistaProyecto(1);
                                                        openModalProyecto();
                                                    }}
                                                >
                                                    {primeraLetraMayusculaOracion(p.nomTicket === '' ? (p.nomTicketIdea || '') : p.nomTicket)}
                                                </div>
                                            </td>
                                            {
                                                tipoProyecto === 0 ?
                                                    <td
                                                        data-label="TIPO TICKET:"
                                                        className='text-center w-[4%]'
                                                    >{p.nomTicketTipo}</td>
                                                : <></>
                                            }
                                            <td data-label="EMPRESA:" className='lg:w-auto w-[10%]'>
                                                <div className='w-[200px] lg:w-auto lg:px-2 text-center whitespace-nowrap overflow-hidden text-ellipsis'>
                                                    {p.nomEmpresa}
                                                </div>
                                            </td>
                                            <td
                                                data-label="RESPONSABLE:"
                                                className='lg:w-auto lg:h-[36px] w-[6%] text-center'
                                            >{p.nomUsuarioResponsable}</td>
                                            <td
                                                data-label="REGISTRADO POR:"
                                                className='lg:w-auto lg:h-[36px] w-[6%] text-center'
                                            >{p.nomUsuarioRegistro}</td>
                                            <td
                                                data-label="F. REGISTRO:"
                                                className="lg:w-auto lg:h-[36px] w-[12px] whitespace-nowrap text-center"
                                            >{p.fechaRegistro}</td>
                                            <td
                                                data-label="F. FIN PROGRAMADO:"
                                                className="lg:w-auto lg:h-[36px] w-[12px] whitespace-nowrap text-center"
                                            >{p.fechaFinProgramado}</td>
                                            <td data-label="DÍAS:" className='text-center lg:w-auto'>
                                                {
                                                    barraProgresoPorFechas(p.fechaInicioProgramado, p.fechaFinProgramado, p.codEstado)
                                                }
                                            </td>
                                            <td data-label="SEGUIMIENTO:" className=''>
                                                <section className='flex items-center gap-x-2 lg:justify-end'>
                                                    {
                                                        p.codEstado === 51 ? '' : 
                                                            <>
                                                                <button
                                                                    key={'agregarSeguimiento_0'+p.codTicket}
                                                                    className='bg-green-500  px-1 rounded hover:shadow-inner'
                                                                    data-tip={'addFollow'}
                                                                    data-for={'addFollow'}
                                                                    onClick={async () => {
                                                                        !esCrearSeguimiento && setEsCrearSeguimiento(true)
                                                                        editarValorNuevoSeguimiento('descripcion','')
                                                                        editarValorNuevoSeguimiento('codTicket',p.codTicket)
                                                                        setValoresSeguimiento({indice: 0, codTicket: p.codTicket})
                                                                        await listarSeguimientoTicket(p.codTicket)
                                                                        await openModalDetalleSeguimiento()
                                                                    }}
                                                                >
                                                                    <i className=' fa fa-plus'></i>
                                                                </button>
                                                                <Tooltip id={'addFollow'} key={'tool_t'+p.codTicket}>Agregar seguimiento</Tooltip>
                                                            </>
                            
                                                    }
                                                    {
                                                        p.seguimiento.length > 0 ?
                                                            <section
                                                                key={p.codTicket + '_' + p.nomTicket}
                                                                className='w-[90%] flex overflow-x-auto containerScroll lg:w-auto'
                                                            >
                                                                {
                                                                    p.seguimiento.map((det, i) => (
                                                                        <>
                                                                            <button
                                                                                key={i + '_' + det.nomSeguimiento}
                                                                                data-tip={det.codSeguimiento + '_'}
                                                                                data-for={det.codSeguimiento + '_'}
                                                                                className={`px-2 bg-blue-500 border border-blue-900 rounded`}
                                                                                onClick={async () => {
                                                                                    esCrearSeguimiento && setEsCrearSeguimiento(false)
                                                                                    await listarSeguimientoTicket(p.codTicket);
                                                                                    setValoresSeguimiento({indice: i + 1, codTicket: p.codTicket})
                                                                                    await openModalDetalleSeguimiento()
                                                                                }}
                                                                            >{i + 1}</button>
                                                                            <Tooltip
                                                                                id={det.codSeguimiento + '_'}
                                                                            >{det.nomSeguimiento}</Tooltip>
                                                                        </>
                                                                    ))
                                                                }
                                                            </section>
                                                        : <></>
                                                    }
                                                </section>
                                                
                                            </td>
                                            <td
                                                data-label="ESTADO:"
                                                className="lg:w-auto text-center"
                                            >
                                                {obtenerEstado( p.codEstado,p.nomEstado, p.codTicket)}
                                            </td>
                                            <td data-label="EDITAR:" className=" w-[50px] text-center">
                                                <i
                                                    className='fa fa-edit text-blue-500 text-xl cursor-pointer'
                                                    onClick={async () => {
                                                        await obtenerIdeaProyecto(p.codTicket)
                                                        await obtenerDetalleInicioProyecto(p.codTicket);
                                                        await asignarFechaActualInicio(p.fechaInicioProgramado||'', p.fechaFinProgramado||'')
                                                        setVistaProyecto(1);
                                                        openModalProyecto();
                                                    }}
                                                    data-tip={'Editar'}
                                                    data-for={'Editar'}
                                                ></i>
                                                <Tooltip id={'Editar'}>Editar</Tooltip>
                                            </td>
                                        </tr>
                                    )
                                })
                            :
                                <tr><td colSpan="12" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                        }
                        </tbody>
                    </table>
                    <table className='hidden' id="tablaOcultaProyectosTotales">
                        <thead>
                            <tr>
                                <th>N°</th>
                                <th>TICKET</th>
                                <th>NOMBRE DEL PROYECTO</th>
                                {
                                    tipoProyecto === 0 
                                    ?   <th>T.TICKET</th>
                                    :   <></>
                                }
                                <th>EMPRESA</th>
                                <th>RESPONSABLE</th>
                                <th>U.CREACIÓN</th>
                                <th>F.REGISTRO</th>
                                <th>F. ENTREGA</th>
                                <th>ESTADO</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                proyectos.length > 0 ?
                                proyectos
                                    .map((p, i) => {
                                        return (
                                            <tr key={i+1} >
                                                <td>{++i}</td>
                                                <td>{p.registroPorPGI ? p.codIncidencia : p.codTicket}</td>
                                                <td>{p.nomTicket === '' ? (p.nomTicketIdea || '') : p.nomTicket}</td>
                                                {
                                                    tipoProyecto === 0 ?
                                                        <td>{p.nomTicketTipo}</td>
                                                    : <></>
                                                }
                                                <td>{p.nomEmpresa}</td>
                                                <td>{p.nomUsuarioResponsable}</td>
                                                <td>{p.nomUsuarioRegistro}</td>
                                                <td>{p.fechaRegistro}</td>
                                                <td>{p.fechaFinProgramado}</td>
                                                <td>{p.nomEstado}</td>
                                            </tr>
                                        )
                                    })
                                :
                                    <tr><td colSpan="12" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                            }
                        </tbody>
                    </table>
                </div>
                {/* <div className='h-[10%]'>
                    <PaginacionABEXA
                        data={dataConFiltros}
                        setDataReturn={setDataPaginada}
                        numeroFilas={100}
                        retornarInicio={true}
                    ></PaginacionABEXA>
                </div> */}
            </ContenedorTabla>

            {/* Modal Proyecto */}
            <ModalProyecto
                isOpen={isOpenModalProyecto}
                closeModal={cerrarModalProyecto}
                action={() => guardarSegunVista()}
                title={`${inicio.identificador === 0 ? 'Registrar Proyecto' : `Editar Proyecto ${inicio.nomTicket}`}`}
                textButtons={{confirm: 'Guardar', denied: 'Cancelar'}}
                validButton={
                    {
                        confirm: (inicio.codEstadoTicket !== 51 && inicio.codEstadoTicket !== 35 ) && (vistaProyecto !== 4 && vistaProyecto !== 5 && (inicio.codTicket !== 0 ? (vistaProyecto !== 1) : true )) ?  true : false,
                        denied: true
                    }
                }
            >
                <div className={`lg:flex-col lg: w-full   lg:flex h-full  overflow-visible`} >
                    <section
                        className='h-[5%] bg-[#1D1E1E] min-h-[28px]'
                        key={'_cabecera'}
                    >
                        {
                            inicio.codTicket !== 0 ?
                                <DetalleProyecto
                                    titulo={inicio.codTicket !== 0 ? `Ticket Nº  ${inicio.codTicket}` : 'Agregar detalle'}
                                    setDespliegue={setDespliegue} despliegue={despliegue}
                                >
                                    <div className='w-full grid grid-cols-2 items-start gap-4 lg:grid-cols-1 lg:gap-y-1'>
                                        <div className='grid grid-cols-[minmax(0,2fr)_minmax(0,8fr)] items-center gap-y-2 lg:grid-cols-[30%_70%] lg:gap-y-1 lg:text-xs'>
                                            <label className='lg:text-sm lg:w-full'>Área destino</label>
                                            <select
                                                className={`${classNameSelect} h-[30px] lg:text-sm lg:h-[30px] lg:w-[100%] text-center`}
                                                onChange={(e) => {
                                                    editarValorInicioProyecto('codAreaDestino',Number(e.target.value));
                                                    listarUsuarios(e.target.value);
                                                    setLimpiarSelect(!limpiarSelect)
                                                }}
                                                value={inicio.codAreaDestino}
                                            >
                                                {
                                                    areas?.length > 0 && inicio.identificador ? '' : 
                                                    <option key={0} value={0}>--Seleccione--</option>
                                                }
                                                {
                                                    areas?.length > 0 ?
                                                        areas.map(a =>(
                                                            <option key={a.codArea} value={a.codArea}>{a.nomArea}</option>
                                                        ))
                                                    :
                                                        <option>-- Seleccione --</option>
                                                }
                                            </select>
                                            <label className='lg:text-sm'>Responsable</label>
                                            <NuevoSelectAutocomplete
                                                options={usuariosConvertidos}
                                                valorInput={(valor) => editarValorInicioProyecto("codUsuarioResponsable",valor)}
                                                valorPorDefecto={inicio.codUsuarioResponsable}
                                                opcionSeleccione={inicio.opcionAutomatizar ? false : true}
                                            ></NuevoSelectAutocomplete>
                                            <label className='lg:text-sm'>Participantes</label>
                                            <MultiSelect
                                                search={true}
                                                data={usuarios}
                                                setEdit ={editarValorInicioProyecto}
                                                keyEdit={'codUsuarioParticipanteConcatenado'}
                                                width={'w-[100%]'}
                                                defaultValue={inicio.codUsuarioParticipanteConcatenado}
                                                isBlocket={false}
                                            />
                                            <label className='lg:text-sm'>Fecha Inicio</label>
                                            <div className='flex lg:gap-2'>
                                                <div className='w-[120px] lg:w-[80px] lg:pr-1'>
                                                    <DatePickerABX
                                                        date={inicio.fechaInicioProgramadoTicket}
                                                        setDate={editarValorInicioProyecto}
                                                        classNameInput={'lg:w-[70px] lg:text-xs lg:p-[2px] bg-zinc-800 border border-zinc-600'}
                                                        keyDate='fechaInicioProgramadoTicket'
                                                        ocultarIcono={true}
                                                    />
                                                </div>
                                                <input
                                                    type='time'
                                                    className={`bg-zinc-800 ${classNameInput} h-[30px] w-[100px] lg:w-[70px] p-1 text-sm lg:text-xs lg:p-[1px]`}
                                                    value={inicio.horaInicioProgramadoTicket}
                                                    onChange={(e) => editarValorInicioProyecto('horaInicioProgramadoTicket',e.target.value)}
                                                    
                                                />
                                            </div>
                                            <label className='lg:text-sm'>Fecha Fin</label>
                                            <div className='flex lg:gap-2'>
                                                <div className='w-[120px] lg:w-[80px] lg:pr-1'>
                                                    <DatePickerABX
                                                        date={inicio.fechaFinProgramadoTicket}
                                                        setDate={editarValorInicioProyecto}
                                                        keyDate={'fechaFinProgramadoTicket'}
                                                        classNameInput={'lg:w-[70px] lg:text-xs lg:p-[2px] bg-zinc-800 border border-zinc-600'}
                                                        ocultarIcono={true}
                                                    />
                                                </div>
                                                <input
                                                    type='time'
                                                    className={`bg-zinc-800 ${classNameInput} h-[30px] w-[100px] lg:w-[70px] p-1 text-sm lg:text-xs lg:p-[1px]`}
                                                    value={inicio.horaFinProgramadoTicket}
                                                    onChange={(e) => editarValorInicioProyecto('horaFinProgramadoTicket',e.target.value)}
                                                />
                                            </div>

                                        </div>
                                        <div className='grid grid-cols-[minmax(0,2fr)_minmax(0,8fr)] items-center gap-y-2 lg:grid-cols-[30%_70%] lg:gap-y-1 lg:text-xs'>
                                            <label className='lg:text-sm'>Empresa</label>
                                            <NuevoSelectAutocomplete
                                                options={empresasConvertidas}
                                                valorInput={(valor) => {editarValorInicioProyecto("codEmpresa",valor);listarUsuariosEmpresa(valor)}}
                                                valorPorDefecto={inicio.codEmpresa}
                                                opcionSeleccione={inicio.identificador ? false : true}
                                            ></NuevoSelectAutocomplete>
                                            <label className='lg:text-sm'>Contacto</label>
                                            <NuevoSelectAutocomplete
                                                options={usuariosEmpresaConvertidos}
                                                valorInput={(valor) => editarValorInicioProyecto("codUsuarioSolicitante",valor)}
                                                valorPorDefecto={inicio.codUsuarioSolicitante}
                                                opcionSeleccione={inicio.identificador ? false : true}
                                            ></NuevoSelectAutocomplete>
                                            <span className='lg:text-sm'>Tipo</span>
                                            <select
                                                className={`${classNameSelect} h-[30px] lg:text-sm lg:h-[30px] lg:w-[100%] text-center `}
                                                onChange={(e) => {
                                                    (!inicio.opcionAutomatizar) && editarValorInicioProyecto('automatizarIncidencia',false)
                                                    editarValorInicioProyecto("codTicketTipo", Number(e.target.value))
                                                }}
                                                value={inicio.codTicketTipo}
                                            >
                                                {
                                                    tiposTickets?.length > 0 && inicio.identificador ? '' : 
                                                    <option key={0} value={0}>--Seleccione--</option>
                                                }
                                                {
                                                    tiposTickets?.length > 0 ?
                                                        tiposTickets.map(tt =>{
                                                            return <option key={tt.codTicketTipo} value={tt.codTicketTipo}>{tt.nomTicketTipo}</option>
                                                        })
                                                    :
                                                        <option key={-1} value={-1}>--Sin información para mostrar--</option>
                                                }
                                            </select>
                                            <label className='lg:text-sm lg:w-full'>Prioridad</label>
                                            <select
                                                className={`${classNameSelect} h-[30px] lg:text-sm lg:h-[30px] lg:w-[100%] text-center`}
                                                onChange={(e)=>editarValorInicioProyecto('codPrioridad',Number(e.target.value))}
                                                value={inicio.codPrioridad}
                                            >
                                                {
                                                    prioridades.length > 0 && inicio.identificador ? '' : 
                                                    <option key={0} value={0}>--Seleccione--</option>
                                                }
                                                {
                                                    prioridades.length > 0 ?
                                                        prioridades.map(p => (
                                                            <option key={p.codPrioridad} value={p.codPrioridad}>{p.nomPrioridad}</option>
                                                        ))
                                                    :
                                                        <option value={-1}>-- Seleccione --</option>
                                                }
                                            </select>
                                            <label className='lg:text-sm lg:w-full'>Creación</label>
                                            <input
                                                className={`bg-zinc-800 ${classNameInput} text-sm p-2 h-[30px] w-[40%]  lg:text-sm lg:h-[30px] lg:w-[100%]`}
                                                readOnly
                                                disabled
                                                value={inicio.fechaRegistro}
                                            />
                                            {
                                                Number(inicio.codTicketTipo) === 3 && inicio.opcionAutomatizar == 0 ?
                                                    <>
                                                        <label className='lg:text-sm lg:w-full'>Automatizar registros</label>
                                                        <SwitchToggle
                                                            keyEdit={"automatizarIncidencia"}
                                                            setEdit={editarValorInicioProyecto}
                                                            valor={inicio.automatizarIncidencia}
                                                        />
                                                    </>
                                                : 
                                                    <></>
                                            }
                                        </div>
                                    </div>
                                </DetalleProyecto>
                            :
                                <></>
                        }
                    </section>
                    <section className='flex lg:flex-col h-[95%] min-w-[150px] lg:w-full '>
                        <section
                            className='w-[15%] min-w-[150px] lg:w-full flex flex-col lg:flex-row overflow-y-auto
                            gap-2 bg-[#2B2C2E] py-5 px-5 lg:py-1 lg:px-1 h-full lg:h-[10%] lg:min-h-0 lg:items-center
                            lg:overflow-y-hidden  lg:overflow-x-auto containerScroll'
                        >
                            <FasesProyecto
                                setVista={setVistaProyecto}
                                vista={vistaProyecto}
                                data={{
                                    codigoIdentificador : inicio.identificador,
                                    codigo: inicio.codTicket,
                                    nombre: inicio.nomTicket,
                                    estado: inicio.codEstadoTicket
                                }}
                                envioImagen={envioImagen}
                                envioDoc={envioDoc}
                            />
                        </section>
                        <section
                            className='flex lg:flex-col w-[85%] min-w[] p-5 lg:p-3 h-full lg:h-[90%] lg:w-full min-h-[300px]'
                        >
                            {
                                vistaProyecto === 1 &&
                                <section className='w-full h-full p-3 lg:p-0 grid
                                grid-cols-[minmax(0,7fr)_minmax(0,3fr)] gap-x-4 lg:grid-cols-1 lg:gap-x-0'
                                >
                                    <section className='flex flex-col '>
                                        <label
                                            htmlFor='nomTituloIdea'
                                            className='text-[#368ad8d0] font-semibold lg:hidden'
                                        >Título de la idea (Necesidad o problema)</label>
                                        <label
                                            htmlFor='nomTituloIdea'
                                            className='text-[#368ad8d0] font-semibold hidden lg:flex'
                                        >Título de la idea</label>
                                        <input
                                            className={`w-full lg:text-xs lg:ml-0 px-2 py-1  ${classNameInput}`}
                                            value={idea.nomTicketIdea}
                                            onChange={(e)=>editarValorIdeaProyecto('nomTicketIdea',e.target.value)}
                                            placeholder='Escribir aquí la necesidad o problema'
                                            id={'nomTituloIdea'}
                                            // disabled={inicio.codTicket === 0 ? false : true}
                                        />
                                        <label
                                            htmlFor='descripcionIdea'
                                            className='text-[#368ad8d0] font-semibold'
                                        >Descripción</label>
                                        <textarea
                                            id={'descripcionIdea'}
                                            className={`flex-grow  lg:text-xs px-2 ${classNameInput} resize-none`}
                                            value={idea.contenidoTicketIdea}
                                            onChange={(e)=> editarValorIdeaProyecto("contenidoTicketIdea",e.target.value )}
                                            placeholder='Escribir aquí la descripción de la idea'
                                        />
                                        <label
                                            className='text-[#368ad8d0] font-semibold lg:w-full'
                                            htmlFor={'solicitanteIdea'}
                                        >Solicitante o autor</label>
                                        <input
                                            id={'solicitanteIdea'}
                                            className={`${classNameInput} w-[100%] lg:text-xs lg:ml-0 lg:w-full  px-2 py-1 `}
                                            value={idea.solicitanteIdea}
                                            onChange={(e) => editarValorIdeaProyecto('solicitanteIdea',e.target.value)}
                                            placeholder='Escribir aquí el nombre de la persona que solicita la idea'
                                        />

                                    </section>
                                    <section className='flex flex-col h-full min-h-0'>
                                        <label className=' text-[#368ad8d0] font-semibold'>Adjunto</label>
                                        <section className='min-h-0 h-full grid grid-rows-[minmax(0,7fr)_minmax(0,3fr)] gap-y-1'>
                                            <ContenedorImagen
                                                envioImagen={envioImagen}
                                                archivo={imagenes}
                                                esBloqueo={inicio.codTicket == 0 ?  false : true}//inicio.codTicket !== 0 ?  true : false}
                                                className={''}
                                            />
                                            <ContenedorDocumento
                                                envioDocumento={envioDoc}
                                                archivo={documentos}
                                                esBloqueo={inicio.codTicket == 0 ?  false : true}//inicio.codTicket !== 0 ?  true : false}
                                                className={''}
                                            />
                                        </section>
                                    </section>
                                </section>
                            }

                            {
                                vistaProyecto === 2 &&
                                    <section
                                        className='w-full h-full p-3 grid lg:p-0
                                        grid-cols-[minmax(0,7fr)_minmax(0,3fr)] gap-x-4 lg:grid-cols-1 lg:gap-x-0'
                                    >
                                        <section className='flex flex-col'>
                                            <label
                                                className='text-[#368ad8d0] font-semibold'
                                                htmlFor='nomTicket'
                                            >Título</label>
                                            <input
                                                id='nomTicket'
                                                className={` w-full lg:text-xs lg:ml-0  px-2 py-1  ${classNameInput}`}
                                                value={inicio.nomTicket}
                                                onChange={(e)=>editarValorInicioProyecto('nomTicket',e.target.value)}
                                                disabled={inicio.identificador}
                                                placeholder='Escribir aquí el título'
                                            />
                                            <label
                                                className='text-[#368ad8d0] font-semibold'
                                                htmlFor='nomObjetivo'
                                            >Objetivo</label>
                                            <textarea
                                                id='nomObjetivo'
                                                className={`w-full lg:text-xs px-2 ${classNameInput} flex-grow resize-none`}
                                                value={inicio.objetivo}
                                                onChange={(e)=> editarValorInicioProyecto("objetivo",e.target.value )}
                                                placeholder='Describa el objetivo del desarrollo...'
                                                disabled={inicio.automatizarIncidencia ? true : false}
                                                readOnly={inicio.automatizarIncidencia ? true : false}
                                            />
                                            <label
                                                className='text-[#368ad8d0] font-semibold'
                                                htmlFor='nomAlcance'
                                            >Alcance</label>
                                            <textarea
                                                id='nomAlcance'
                                                className={` w-full lg:text-xs flex-grow px-2 ${classNameInput} resize-none`}
                                                value={inicio.alcance}
                                                onChange={(e)=> editarValorInicioProyecto("alcance",e.target.value )}
                                                placeholder='Describa el alcance del proyecto, incidencia o requerimiento'
                                                disabled={inicio.automatizarIncidencia ? true : false}
                                                readOnly={inicio.automatizarIncidencia ? true : false}
                                            />
                                            <label
                                                className='text-[#368ad8d0] font-semibold'
                                                htmlFor='nomInteresados'
                                            >Interesados o patrocinador</label>
                                            <textarea
                                                id='nomInteresados'
                                                className={` w-full lg:text-xs flex-grow px-2 ${classNameInput} resize-none`}
                                                value={inicio.interesados}
                                                onChange={(e)=> editarValorInicioProyecto("interesados",e.target.value )}
                                                placeholder='Escribir aquí quienes estan interesados en el proyecto'
                                                disabled={inicio.automatizarIncidencia ? true : false}
                                                readOnly={inicio.automatizarIncidencia ? true : false}
                                            />
                                        </section>
                                        <section className='flex flex-col h-full min-h-0'>
                                            <label className=' text-[#368ad8d0] font-semibold'>Adjunto</label>
                                            <section className='h-full grid grid-rows-[minmax(0,7fr)_minmax(0,3fr)] gap-y-1 min-h-0'>
                                                <div className='overflow-auto'>
                                                    <ContenedorImagen
                                                        envioImagen={envioImagen}
                                                        archivo={imagenes}
                                                        esBloqueo={false}//inicio.codTicket !== 0 ?  true : false}
                                                        className={''}
                                                    />
                                                </div>
                                                <ContenedorDocumento
                                                    envioDocumento={envioDoc}
                                                    archivo={documentos}
                                                    esBloqueo={false}//inicio.codTicket !== 0 ?  true : false}
                                                    className={''}
                                                />
                                            </section>
                                        </section>
                                    </section>
                            }
                            {
                                vistaProyecto === 3 &&
                                (
                                    !vistaHistorial ? 
                                    <section
                                        className={`w-full h-full p-3 lg:p-0 grid
                                        grid-cols-[minmax(0,7fr)_minmax(0,3fr)] gap-x-4 lg:grid-cols-1 lg:gap-x-0 `}
                                    >
                                        <section className='flex flex-col'>
                                            <label
                                                className='text-[#368ad8d0] font-semibold'
                                                htmlFor='tituloAnalisis'
                                            >Título análisis</label>
                                            <input
                                                id='tituloAnalisis'
                                                className={`px-2 py-1 w-full ${classNameInput} `}
                                                onChange={(e) => editarValorAnalisisProyecto('titulo', e.target.value)}
                                                value={analisis.titulo}
                                                placeholder='Escriba aquí el titulo de su analisis'
                                            />
                                            <label
                                                className='text-[#368ad8d0] font-semibold'
                                                htmlFor='descripcionAnalisis'
                                            >Descripción</label>
                                            <textarea
                                                id='descripcionAnalisis'
                                                className={`w-full ${classNameInput} flex-grow px-2 py-1 resize-none`}
                                                onChange={(e) => editarValorAnalisisProyecto('descripcionAnalisis', e.target.value)}
                                                value={analisis.descripcionAnalisis}
                                                placeholder='Descripción breve de su análisis'
                                            />
                                            <div className='w-full grid grid-cols-[minmax(0,3fr)_minmax(0,7fr)] gap-x-2'>
                                                <span className='text-[#368ad8d0] font-semibold '>Fecha hora inicio</span>
                                                <span className='text-[#368ad8d0]'>Participantes</span>
                                                <div className='flex gap-1 w-full'>
                                                    <DatePickerABX
                                                        date={analisis.fechaInicioAnalisis}
                                                        setDate={editarValorAnalisisProyecto}
                                                        classNameInput={`${classNameInput} flex-grow`}
                                                        keyDate='fechaInicioAnalisis'
                                                        ocultarIcono={true}
                                                    />
                                                    <input
                                                        type='time'
                                                        className={`${classNameInput} flex-grow lg:w-[90px] w-[100px] px-2 py-1 text-sm`}
                                                        defaultValue={analisis.horaInicioAnalisis}
                                                        onChange={(e) => editarValorAnalisisProyecto('horaInicioAnalisis',e.target.value)}
                                                    />
                                                </div>
                                                <div className='flex-grow'>
                                                    <MultiSelect
                                                        search={true}
                                                        data={usuarios}
                                                        setEdit ={editarValorAnalisisProyecto}
                                                        keyEdit={'codUsuarioParticipanteConcatenado'}
                                                        width={'w-[100%]'}
                                                        defaultValue={analisis.codUsuarioParticipanteConcatenado}
                                                        isBlocket={false}
                                                        classNameSelect={'bg-zinc-900 border border-zinc-600'}
                                                    />
                                                </div>
                                            </div>
                                            <span className='text-[#368ad8d0] font-semibold'>Fecha hora fin</span>
                                            <div className='flex gap-1 w-[30%]'>
                                                <DatePickerABX
                                                    date={analisis.fechaFinAnalisis}
                                                    setDate={editarValorAnalisisProyecto}
                                                    classNameInput={' lg:w-[100px] w-[150px] lg:text-xs lg:p-[2px] bg-zinc-900 border border-zinc-600 '}
                                                    keyDate='fechaFinAnalisis'
                                                    ocultarIcono={true}
                                                />
                                                <input
                                                    type='time'
                                                    className={`${classNameInput} lg:w-[90px] flex-grow px-2 py-1 text-sm`}
                                                    value={analisis.horaFinAnalisis}
                                                    onChange={(e) => editarValorAnalisisProyecto('horaFinAnalisis',e.target.value)}
                                                />
                                            </div>
                                            <div className='pt-2'>
                                                <button
                                                    className={`bg-slate-500 w-[100px] p-1 rounded-md`}
                                                    onClick={() => setVistaHistorial(true)}
                                                >Ver historial</button>
                                            </div>
                                            
                                        </section>
                                        <section className='flex flex-col h-full min-h-0'>
                                            <label className=' text-[#368ad8d0] font-semibold'>Prototipo</label>
                                            <section className='h-full min-h-0 grid grid-rows-[minmax(0,7fr)_minmax(0,3fr)] gap-y-1'>
                                                <ContenedorImagen
                                                    envioImagen={envioImagen}
                                                    archivo={imagenes}
                                                    esBloqueo={false}//inicio.codTicket !== 0 ?  true : false}
                                                    className={''}
                                                />
                                                <ContenedorDocumento
                                                    envioDocumento={envioDoc}
                                                    archivo={documentos}
                                                    esBloqueo={false}//inicio.codTicket !== 0 ?  true : false}
                                                    className={''}
                                                />
                                            </section>
                                        </section>
                                    </section>
                                    :
                                    <section className='w-full overflow-x-auto containerScroll'>
                                        <table className='tableResponsive'>
                                            <thead>
                                                <tr>
                                                    <th className='w-[5%] text-center'>N</th>
                                                    <th className='w-[35%] min-w-[35%]'>DESCRIPCION</th>
                                                    <th className='w-[10%]'>PARTICIPANTES</th>
                                                    <th className='w-[10%]'>F. INICIO</th>
                                                    <th className='w-[10%]'>F. FIN</th>
                                                    <th className='w-[10%]'>U. CREACIÓN</th>
                                                    <th className='w-[10%] whitespace-nowrap'>F. CREACIÓN</th>
                                                    <th className='w-[5%]'></th>
                                                    <th className='w-[5%]'></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    listaAnalisis?.length > 0 ? 
                                                        listaAnalisis.map((data, i) => (
                                                            <tr onClick={(e)=> pintarFila(e.target)}>
                                                                <td className='w-[5%] text-center'>{i + 1}</td>
                                                                <td className='w-[350px]'
                                                                    data-tip={'descripcion_' + (data.codTicketAnalisis||0)}
                                                                    data-for={'descripcion_' + (data.codTicketAnalisis||0)}
                                                                    >
                                                                    <div className='whitespace-nowrap overflow-hidden text-ellipsis w-[345px]'>
                                                                        {data.descripcionAnalisis}
                                                                    </div>
                                                                    <Tooltip id={'descripcion_' + (data.codTicketAnalisis||0)}>{data.descripcionAnalisis}</Tooltip>
                                                                </td>
                                                                <td className='w-[150px]'
                                                                    title={data.nomUsuarioParticipanteConcatenado}
                                                                    data-tip={'participantes_' + (data.codTicketAnalisis||0)}
                                                                    data-for={'participantes_' + (data.codTicketAnalisis||0)}
                                                                >
                                                                    <div className='w-[145px] whitespace-nowrap overflow-hidden text-ellipsis'>
                                                                        {data.nomUsuarioParticipanteConcatenado}
                                                                    </div>
                                                                    <Tooltip id={'participantes_' + (data.codTicketAnalisis||0)}>{data.nomUsuarioParticipanteConcatenado}</Tooltip>
                                                                </td>
                                                                <td className='whitespace-nowrap w-[10%]'>{data.fechaInicioReal}</td>
                                                                <td className='whitespace-nowrap w-[10%]'>{data.fechaFinReal}</td>
                                                                <td className='whitespace-nowrap w-[10%]'>{data.nomUsuarioRegistro}</td>
                                                                <td className='w-[5%] whitespace-nowrap'>{data.fechaRegistro}</td>
                                                                <td className=' w-[5%] text-center'>
                                                                    {
                                                                        data.parametrosArchivo.length > 0 || data.parametrosImagen.length > 0 ? 
                                                                            <i
                                                                                className='fa fa-file text-blue-500'
                                                                                onClick={async () => {
                                                                                    let urlDocumento = data.parametrosArchivo.length > 0 ? await parseURLArchivo(data.parametrosArchivo) : [];
                                                                                    let urImagen = data.parametrosImagen.length > 0 ? await parseURLArchivo(data.parametrosImagen) : [];
                                                                                    setAnalisisImagen(urImagen)
                                                                                    setAnalisisDoc(urlDocumento)
                                                                                    openModalImagen()
                                                                                }}
                                                                            ></i>
                                                                        :
                                                                            <></>
                                                                    }
                                                                </td>

                                                                <td className=' w-[5%] text-center'>   
                                                                    <i
                                                                        className=' fa fa-ligth fa-trash text-red-500'
                                                                        onClick={async () => { 
                                                                            const isValid = await eliminarAnalisisProyecto(data.codTicketAnalisis)
                                                                            isValid && obtenerAnalisisProyecto(inicio.codTicket)
                                                                        }}
                                                                    ></i>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    :
                                                    <tr><td colSpan={10} className='text-center'>No hay información para mostrar...</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                        <section className='px-2 py-4'>
                                            <button
                                                className='bg-slate-500 w-[200px] p-1 rounded-md'
                                                onClick={() => setVistaHistorial(false)}
                                            ><i className='fa fa-reply pr-2'></i>Regresar al registro</button>
                                        </section>
                                    </section>

                                )
                            }
                            {
                                vistaProyecto === 4 &&
                                    <section className='w-full overflow-y-auto containerScroll lg:h-full'>
                                        <div className="text-xs h-full flex ">
                                            <div className="">
                                                <div className=' cuadroProyecto p-0 w-[50%] left-[25%] right-[25%]'>
                                                    <div className='h-full flex items-center'>
                                                        <div className='flex gap-2 justify-center items-center px-2 w-[100%]'>
                                                            <span
                                                                className='text-xl whitespace-nowrap text-ellipsis overflow-hidden lg:text-xs w-[95%] h-full'
                                                                data-tip={'nombreEntregable'+entregableActividades.codTicket}
                                                                data-for={'nombreEntregable'+entregableActividades.codTicket}
                                                            >
                                                                {entregableActividades.nomTicket || ''}
                                                            </span>
                                                            <Tooltip id={'nombreEntregable'+entregableActividades.codTicket}>{entregableActividades.nomTicket || ''}</Tooltip>
                                                            <i
                                                                className='fa fa-plus-circle w-[5%] h-full text-base cursor-pointer hover:text-blue-500'
                                                                data-tip={'crearEntregable'+entregableActividades.codTicket}
                                                                data-for={'crearEntregable'+entregableActividades.codTicket}
                                                                onClick={async () => {
                                                                    await listarUsuarioTicketProyecto(entregableActividades.codTicket);
                                                                    await obtenerDetalleEntregable();
                                                                    asignarFechaActualEntregable()
                                                                    openModalEntregable()
                                                                }}
                                                            ></i>
                                                            <Tooltip id={'crearEntregable'+entregableActividades.codTicket}>Crear entregable</Tooltip>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='flex border-b-4 h-[20px] w-full min-w-[600px]'>
                                                    <div className='flex  border-r-2 w-[50%]'></div>
                                                    <div className='flex  border-l-2 w-[50%]'></div>
                                                </div>

                                                <div className='z-5 h-[20px]'></div>
                                                <ul className="flex">
                                                    {
                                                        entregableActividades.entregable.length > 0 &&
                                                            entregableActividades.entregable.map((entregable,i) => {
                                                                return(
                                                                    entregable.codTicketEntregable !== 0 &&
                                                                    <>

                                                                        <li
                                                                            key={entregable.codTicketEntregable + (i + 1)}
                                                                            className='cuadroActividades h-full flex flex-col gap-4 w-[200px] p-2 '
                                                                        >
                                                                            <div className='cuadroEntregable rounded-lg'>
                                                                                <p
                                                                                    className='hover:text-blue-500 hover:decoration-blue-500
                                                                                    cursor-pointer py-1 text-sm decoration-white
                                                                                    whitespace-nowrap text-ellipsis overflow-hidden text-center'
                                                                                    data-tip={'entregable'+entregable.codTicketEntregable}
                                                                                    data-for={'entregable'+entregable.codTicketEntregable}
                                                                                    onClick={async () => {
                                                                                        await listarUsuarioTicketProyecto(entregableActividades.codTicket)
                                                                                        await obtenerDetalleEntregable(entregable.codTicketEntregable);
                                                                                        openModalEntregable()
                                                                                    }}
                                                                                >
                                                                                    {entregable.nomEntregable}
                                                                                </p>
                                                                                <Tooltip id={'entregable'+entregable.codTicketEntregable}>{entregable.nomEntregable}</Tooltip>
                                                                                <i
                                                                                    className='fa fa-plus-circle cursor-pointer px-2 hover:text-blue-500'
                                                                                    data-for={'crearActividad'}
                                                                                    data-tip={'crearActividad'}
                                                                                    onClick={async () => {
                                                                                        await listarUsuarioTicketEntregable(entregable.codTicketEntregable)
                                                                                        await obtenerActividadDetalle()
                                                                                        await listarActividad(entregable.codTicketEntregable)
                                                                                        editarValorActividad('codTicketEntregable',entregable.codTicketEntregable);
                                                                                        asignarFechaActualActividad()
                                                                                        openModalActividad();
                                                                                    }}
                                                                                ></i>
                                                                                <Tooltip id={'crearActividad'}>Crear Actividad</Tooltip>
                                                                            </div>
                                                                            {
                                                                                entregable.actividades[0].codEstadoTicketActividad === 0 &&
                                                                                <>
                                                                                    <i
                                                                                        className='fa fa-times-circle absolute top-1 right-1 cursor-pointer z-10'
                                                                                        data-for={'eliminarEntregable'}
                                                                                        data-tip={'eliminarEntregable'}
                                                                                        onClick={() => {
                                                                                            editarValorActividad('codTicketActividad', 0);
                                                                                            editarValorActividad('codTicketEntregable', entregable.codTicketEntregable);
                                                                                            openModalEliminarEntregable();
                                                                                        }}
                                                                                    ></i>
                                                                                    <Tooltip id={'eliminarEntregable'}>Eliminar entregable</Tooltip>
                                                                                </>
                                                                            }
                                                                            <div>
                                                                                <ul className='border-l-4 w-[100%] flex flex-col gap-3 '>
                                                                                    {
                                                                                        entregable?.actividades?.map((actividad, subIndex) => (
                                                                                            actividad.codTicketActividad !== 0 &&
                                                                                            <li key={subIndex} className=''>
                                                                                                <section
                                                                                                    className='rounded  flex items-center'
                                                                                                    onAuxClick={()=> copiarTexto('Ticket Nº ' + inicio.codTicket +'\n'+ 'Actividad: ' + actividad.codTicketActividad)}
                                                                                                >
                                                                                                    <span
                                                                                                        className='hover:text-blue-500 hover:decoration-blue-500 cursor-pointer p-1
                                                                                                        text-sm decoration-white w-[95%] whitespace-nowrap text-ellipsis overflow-hidden'
                                                                                                        data-tip={'nombreActividad'+actividad.codTicketActividad}
                                                                                                        data-for={'nombreActividad'+actividad.codTicketActividad}
                                                                                                        onClick={async () => {
                                                                                                            await listarUsuarioTicketEntregable(entregable.codTicketEntregable)
                                                                                                            await obtenerActividadDetalle(actividad.codTicketActividad);
                                                                                                            await listarActividad(entregable.codTicketEntregable);
                                                                                                            openModalActividad()
                                                                                                        }}
                                                                                                    >{actividad.nomActividad}</span>
                                                                                                    <Tooltip id={'nombreActividad'+actividad.codTicketActividad}>{actividad.nomActividad}</Tooltip>
                                                                                                </section>
                                                                                                {
                                                                                                    actividad.codEstadoTicketActividad === 9 &&
                                                                                                        <>
                                                                                                            <i
                                                                                                                className='fa fa-times-circle text-red-500 cursor-pointer absolute top-2  -right-3 '
                                                                                                                data-for={'eliminarActividad'}
                                                                                                                data-tip={'eliminarActividad'}
                                                                                                                onClick={() => {
                                                                                                                    editarValorActividad('codTicketEntregable', 0);
                                                                                                                    editarValorActividad('codTicketActividad',actividad.codTicketActividad);
                                                                                                                    openModalEliminarEntregable();
                                                                                                                }}
                                                                                                            ></i>
                                                                                                            <Tooltip id={'eliminarActividad'}>Eliminar actividad</Tooltip>
                                                                                                            <i
                                                                                                                className="fa fa-check-circle text-green-500 cursor-pointer absolute top-6 -right-3"
                                                                                                                data-for={'regularizarActividad'}
                                                                                                                data-tip={'regularizarActividad'}
                                                                                                                onClick={() => registrarActividadRegularizada(actividad.codTicketActividad)}
                                                                                                            ></i>
                                                                                                            <Tooltip id={'regularizarActividad'}>Regularizar actividad</Tooltip>
                                                                                                        </>
                                                                                                    }

                                                                                            </li>

                                                                                        ))
                                                                                    }
                                                                                </ul>
                                                                            </div>
                                                                        </li>
                                                                    </>
                                                                )
                                                            })
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </section>
                            }
                            {
                                vistaProyecto === 5 &&
                                    <div className='w-full'>
                                        <div className=" containerScroll text-xs relative top-0 h-[480px] max-h-[480px]  bottom-0 left-0 right-0 contenedor-tabla" >
                                            <table className=" tableResponsive  ">
                                                <thead className=''>
                                                    <tr>
                                                        <th className="w-[10px]">N°</th>
                                                        <th className="w-[20px]">COD</th>
                                                        <th className="w-[20px]">ENTREGABLE</th>
                                                        <th className="w-[250px]">ACTIVIDAD</th>
                                                        <th className="w-[100px]">RESPONSABLE</th>
                                                        <th className="w-[100px] whitespace-nowrap">F.INICIO PROG.</th>
                                                        <th className="w-[100px] whitespace-nowrap">F.FIN PROG.</th>
                                                        <th className="w-[100px] whitespace-nowrap">F.INICIO REAL</th>
                                                        <th className="w-[100px] whitespace-nowrap">F.FIN REAL</th>
                                                        <th className="w-[100px]">ESTADO</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {

                                                    actividadesAgrupadas?.length > 0 ?
                                                        (
                                                            actividadesAgrupadas.map((entregable, i) => {
                                                                return entregable.actividades.map((actividad,j) => {
                                                                    return(
                                                                        <>
                                                                            <tr key={entregable.codTicketEntregable}>
                                                                                {
                                                                                    (j === 0) && (
                                                                                        <>
                                                                                            <td rowSpan={entregable.cantidadFilas} className='w-[40px] text-center'>
                                                                                                <span className='w-[40px]'>{i+1}</span>
                                                                                            </td>
                                                                                            <td rowSpan={entregable.cantidadFilas} className='text-center min-w-[70px] w-[70px]'>
                                                                                                <div className='w-[70px] text-center'>
                                                                                                    <span className='bg-green-500 px-2 py-1 rounded'>{entregable.codTicketEntregable}</span>
                                                                                                </div>
                                                                                            </td>
                                                                                            <td rowSpan={ entregable.cantidadFilas} >
                                                                                                <div className='w-[250px] flex gap-2 items-center'>
                                                                                                    <span className='whitespace-nowrap w-[90%] text-ellipsis overflow-hidden '>{entregable.nomEntregable}</span>
                                                                                                </div>
                                                                                            </td>
                                                                                        </>
                                                                                    )
                                                                                }
                                                                                <td>
                                                                                    <div className='whitespace-nowrap text-ellipsis overflow-hidden w-[200px] px-1 py-1'>
                                                                                        <span
                                                                                            className='bg-blue-600 px-2 rounded mr-1'
                                                                                            onClick={() => copiarTexto('Ticket Nº ' + inicio.codTicket +'\n'+ 'Actividad: ' + actividad.codTicketActividad)}
                                                                                        >{actividad.codTicketActividad}</span>
                                                                                        <span data-tip={'nomActividad'+j+'-'+actividad.codTicketActividad} data-for={'nomActividad'+j+'-'+actividad.codTicketActividad}>{actividad.nomActividad}</span>
                                                                                        <Tooltip id={'nomActividad'+j+'-'+actividad.codTicketActividad}>{actividad.nomActividad}</Tooltip>
                                                                                    </div>
                                                                                </td>
                                                                                <td>
                                                                                    <span>{actividad.nomUsuarioResponsable}</span>
                                                                                </td>
                                                                                <td>
                                                                                    <span className='whitespace-nowrap'>{actividad.fechaInicioProgramado}</span>
                                                                                </td>
                                                                                <td>
                                                                                    <span className='whitespace-nowrap'>{actividad.fechaFinProgramado}</span>
                                                                                </td>
                                                                                <td>
                                                                                    <span className='whitespace-nowrap'>{actividad.fechaInicioReal}</span>
                                                                                </td>
                                                                                <td>
                                                                                    <span className='whitespace-nowrap'>{actividad.fechaFinReal}</span>
                                                                                </td>
                                                                                <td className='whitespace-nowrap'>
                                                                                    {obtenerEstadoActividad(actividad.codEstadoTicketActividad)}
                                                                                </td>

                                                                            </tr>
                                                                        </>
                                                                    )
                                                                })
                                                            })
                                                        )
                                                    : <tr><td colSpan="9" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                            }
                            {
                                vistaProyecto === 6 &&
                                    <section className='w-full h-full p-3 lg:p-0 grid lg:gap-x-0 gap-x-4
                                        grid-cols-[minmax(0,7fr)_minmax(0,3fr)]  lg:grid-cols-1'
                                    >
                                        <section className='flex flex-col'>
                                            <label
                                                className='font-semibold text-[#368ad8d0]'
                                                htmlFor='txtComentarioCierre'
                                            >Comentario de cierre</label>
                                            <textarea
                                                id='txtComentarioCierre'
                                                value={finProyecto.motivoFinalizaDirecto}
                                                className={`${classNameInput} h-[260px] resize-none p-2`}
                                                onChange={(e) => editarValorFinalizarProyecto('motivoFinalizaDirecto', e.target.value)}
                                            />
                                        </section>
                                        <section className='flex flex-col h-full min-h-0'>
                                            <label className=' text-[#368ad8d0] font-semibold'>Adjunto</label>
                                            <section className='h-full min-h-0 grid grid-rows-[minmax(0,7fr)_minmax(0,3fr)] gap-y-1'>
                                                <ContenedorImagen
                                                    envioImagen={envioImagen}
                                                    archivo={imagenes}
                                                    esBloqueo={false}//inicio.codTicket !== 0 ?  true : false}
                                                    className={''}
                                                />
                                                <ContenedorDocumento
                                                    envioDocumento={envioDoc}
                                                    archivo={documentos}
                                                    esBloqueo={false}//inicio.codTicket !== 0 ?  true : false}
                                                    className={''}
                                                />
                                            </section>
                                        </section>
                                        
                                    </section>
                            }
                            {
                                vistaProyecto === 7 && 
                                <section className='w-full h-full p-3 lg:p-0 grid lg:gap-x-0 gap-x-4
                                        grid-cols-[minmax(0,7fr)_minmax(0,3fr)]  lg:grid-cols-1'
                                >
                                    <section className='flex flex-col'>
                                        <div 
                                            className={`${inicio.codEstadoTicket == 9 ? 'hidden ' : 'grid '} grid grid-cols-2 col-span-2 gap-x-2`}
                                        >
                                            <label
                                                htmlFor='U.Rechazo'
                                                className='text-[#368ad8d0] font-semibold'
                                            >Uusuario rechazo</label>
                                            <label
                                                htmlFor='U.Rechazo'
                                                className='text-[#368ad8d0] font-semibold'
                                            >Fecha eliminación</label>
                                            <input
                                                className={`w-full lg:text-xs lg:ml-0 px-2 py-1  ${classNameInput}`}
                                                value={inicio.nomUsuarioRechazo}
                                                disabled
                                            />
                                            <input
                                                className={`w-full lg:text-xs lg:ml-0 px-2 py-1  ${classNameInput}`}
                                                value={inicio.fechaHoraRechazo}
                                                disabled
                                            />
                                        </div>
                                        <label
                                            htmlFor='descripcionIdea'
                                            className='text-[#368ad8d0] font-semibold'
                                        >Motivo</label>
                                        <textarea
                                            className={`h-48 lg:text-xs px-2 ${classNameInput} resize-none`}
                                            value={inicio.motivoRechazo}
                                            onChange={(e)=> editarValorInicioProyecto("motivoRechazo", e.target.value )}
                                            placeholder='Escribir aquí el motivo de rechazo...'
                                            disabled={inicio.codEstadoTicket === 9 ? false : true}
                                        />

                                    </section>
                                    <section className='flex flex-col h-full min-h-0'>
                                        <label className=' text-[#368ad8d0] font-semibold'>Adjunto</label>
                                        <section className='min-h-0 h-full grid grid-rows-[minmax(0,7fr)_minmax(0,3fr)] gap-y-1'>
                                            <ContenedorImagen
                                                envioImagen={envioImagen}
                                                archivo={imagenes}
                                                esBloqueo={inicio.codEstadoTicket === 9 ?  false : true}//inicio.codTicket !== 0 ?  true : false}
                                                className={''}
                                            />
                                        </section>
                                    </section>
                                </section>
                            }
                        </section>
                    </section>
                </div>
            </ModalProyecto>

            {/* MODAL ENTREGABLE */}
            <Modal
                isOpen={isOpenModalEntregable}
                closeModal={closeModalEntregable}
                action={()=> registrarEntregable()}
                title={`${entregable.codTicketEntregable === 0 ? 'Crear entregable' : 'Editar entregable'}`}

            >
                <div className=' w-[500px] grid grid-cols-[25%_75%] gap-y-2 items-center'>
                    <label htmlFor='txtNomEntregable'>Nombre</label>
                    <input
                        id='txtNomEntregable'
                        className={`${classNameInput} p-1`}
                        onChange={(e) => {
                                editarValorEntregable('nomEntregable',e.target.value)
                                entregable.codUsuarioResponsable === 0  && editarValorEntregable('codUsuarioResponsable',usuariosProyecto[0].codUsuario)
                            }
                        }
                        value={entregable?.nomEntregable}
                    />
                    <label>Responsable</label>
                    <NuevoSelectAutocomplete
                        options={usuariosProyectoConvertidos}
                        valorInput={(valor) => editarValorEntregable('codUsuarioResponsable',valor)}
                        valorPorDefecto={entregable.codUsuarioResponsable}
                    ></NuevoSelectAutocomplete>
                    <span >Participantes</span>
                    <MultiSelect
                        search={true}
                        data={usuariosProyecto}
                        setEdit ={editarValorEntregable}
                        width={'w-[100%]'}
                        keyEdit={'codUsuarioParticipanteConcatenado'}
                        defaultValue={entregable.codUsuarioParticipanteConcatenado}
                        isBlocket={false}
                        classNameSelect={'bg-zinc-900 border border-zinc-600'}
                    />
                    <span>Fecha inicio</span>
                    <div className='flex gap-2 items-center'>
                        <DatePickerABX
                            date={entregable.fechaInicioProgramadoEntregable}
                            setDate={editarValorEntregable}
                            classNameInput={`${classNameInput} w-[150px] lg:w-[90px] lg:text-xs lg:p-[2px]`}
                            keyDate='fechaInicioProgramadoEntregable'
                            ocultarIcono={true}
                        />
                        <input
                            type='time'
                            className={`${classNameInput} w-[100px] p-1 text-sm`}
                            value={entregable.horaInicioProgramadoEntregable}
                            onChange={(e) => editarValorEntregable('horaInicioProgramadoEntregable',e.target.value)}
                        />
                    </div>
                    <span>Fecha fin</span>
                    <div className='flex gap-2 items-center'>
                        <DatePickerABX
                            date={entregable.fechaFinProgramadoEntregable}
                            setDate={editarValorEntregable}
                            classNameInput={`${classNameInput} lg:w-[90px] lg:text-xs lg:p-[2px]`}
                            keyDate='fechaFinProgramadoEntregable'
                            ocultarIcono={true}
                        />
                        <input
                            type='time'
                            className={`${classNameInput} w-[100px] p-1 text-sm`}
                            value={entregable.horaFinProgramadoEntregable}
                            onChange={(e) => editarValorEntregable('horaFinProgramadoEntregable',e.target.value)}
                        />
                    </div>
                </div>
            </Modal>

            {/* MODAL ACTIVIDADES */}
            <Modal
                isOpen={isOpenModalActividad}
                closeModal={closeModalActividad}
                action={() => registrarActividad()}
                // title={actividad.codTicketActividad === 0 ? `Crear Actividad` : `Editar [ ${actividad.nomActividad} ]`}
                title={actividad.codTicketActividad === 0 ? `Crear Actividad` : `Editar actividad`}
                validButton={{confirm: true, denied: true, other: true}}
                textButtons={{confirm: 'Guardar', denied: 'Cerrar', other: 'Tareas'}}
                actionOtherButton={()=> console.log('Otro boton ')}
            >
                <div className=' w-[450px] grid grid-cols-[25%_75%] gap-y-2 items-center'>
                    <label htmlFor='txtNomActividad'>Nombre</label>
                    <textarea
                        id='txtNomActividad'
                        className={`${classNameInput} p-1 h-[80px] text-base`}
                        onChange={(e)=> {
                            editarValorActividad('nomActividad',e.target.value);
                            actividad.codUsuarioResponsable === 0 && editarValorActividad('codUsuarioResponsable',usuariosEntregable[0].codUsuario)
                        }}
                        value={actividad.nomActividad}
                    >
                    </textarea>
                    <label>Responsable</label>
                    <NuevoSelectAutocomplete
                        options={usuariosEntregableConvertidos}
                        valorInput={(valor) => editarValorActividad("codUsuarioResponsable",valor)}
                        valorPorDefecto={actividad.codUsuarioResponsable}
                    ></NuevoSelectAutocomplete>
                    <label>Fecha inicio</label>
                    <div className='flex gap-4'>
                        <DatePickerABX
                            date={actividad.fechaInicioProgramadoActividad}
                            setDate={editarValorActividad}
                            classNameInput={'lg:w-[90px] lg:text-xs lg:p-[2px] bg-zinc-900 border border-zinc-600 '}
                            keyDate='fechaInicioProgramadoActividad'
                            ocultarIcono={true}
                        />
                        <input
                            type='time'
                            className={`${classNameInput} w-[100px] p-1 text-sm`}
                            value={actividad.horaInicioProgramadoActividad}
                            onChange={(e) => editarValorActividad('horaInicioProgramadoActividad',e.target.value)}
                        />
                    </div>
                    <label>Fecha fin</label>
                    <div className='flex gap-4'>
                        <DatePickerABX
                            date={actividad.fechaFinProgramadoActividad}
                            setDate={editarValorActividad}
                            classNameInput={'lg:w-[90px] lg:text-xs lg:p-[2px]  bg-zinc-900 border border-zinc-600'}
                            keyDate='fechaFinProgramadoActividad'
                            ocultarIcono={true}
                        />
                        <input
                            type='time'
                            className={`${classNameInput} w-[100px] p-1 text-sm`}
                            value={actividad.horaFinProgramadoActividad}
                            onChange={(e) => editarValorActividad('horaFinProgramadoActividad',e.target.value)}
                        />
                    </div>
                    <label>Dependencia</label>
                    <select
                        className={`${classNameSelect}`}
                        value={actividad.codTicketActividadPredecesor}
                        onChange={(e) => editarValorActividad('codTicketActividadPredecesor',e.target.value)}
                    >
                        <option value={''} key={'ninguna'}>--Ninguna--</option> 
                        {
                            actividades.length > 0 ? 
                                actividades.map((act,i) => (
                                    <option
                                        value={act.codTicketActividad}
                                        key={act.codTicketActividad}
                                        className={`${actividad.codTicketActividad === act.codTicketActividad ? 'hidden' : ''}`}
                                    >{act.nomActividad}</option>   
                                ))
                            :
                                ''
                                // <option value={0} key={'sinInfo'}>--No hay información--</option>
                        }
                    </select>
                    <label>Prioridad</label>
                    <select
                        className={`${classNameSelect} w-[50%]`}
                        value={actividad.codPrioridad}
                        onChange={(e) => editarValorActividad('codPrioridad',Number(e.target.value))}
                    >
                        {
                            prioridades.length > 0 ?
                                prioridades.map(p => (
                                    <option key={p.codPrioridad} value={p.codPrioridad}>{p.nomPrioridad}</option>
                                ))
                            :
                                <option value={0}>--Sin información--</option>
                        }
                    </select>
                    <label>Complejidad</label>
                    <select
                        className={`${classNameSelect} w-[50%]`}
                        value={actividad.codComplejidad}
                        onChange={(e) => editarValorActividad('codComplejidad',Number(e.target.value))}
                    >
                        {
                            prioridades.length > 0 ?
                                prioridades.map(p => (
                                    <option key={p.codPrioridad} value={p.codPrioridad}>{p.nomPrioridad}</option>
                                ))
                            :
                                <options value={0}>--Sin información--</options>
                        }
                    </select>
                </div>
            </Modal>

            {/* MODAL PARA ELIMINAR ENTREGABLE / ACTIVIDAD */}
            <Modal
                isOpen={isOpenModalEliminarEntregable}
                closeModal={closeModalEliminarEntregable}
                title={`Eliminar ${ actividad.codTicketEntregable !== 0 ? ' entregable ': ' actividad '}`}
                action={() => actividad.codTicketActividad ? registrarEliminarActividad() : registrarEliminarEntregable(actividad.codTicketEntregable)}
            >
                <div className='flex items-center gap-2'>
                    <img
                        src='https://upload.wikimedia.org/wikipedia/commons/1/11/Blue_question_mark_icon.svg'
                        className='w-[40px] h-[40px]'
                        alt=''
                    />
                    <span>¿Esta seguro de realizar la operación ?</span>
                </div>
            </Modal>

            <Modal
                isOpen={isOpenModalDetalleSeguimiento}
                closeModal={closeModalDetalleSeguimiento}
                title={`Detalle seguimiento [ TICKET N°${valoresSeguimiento.codTicket} ]`}
                validButton={{confirm: false, denied: true}}
            >
                <div className='h-[400px] w-[900px] overflow-y-auto containerScroll lg:w-auto'>
                    <table className='tableResponsive'>
                        <thead>
                            <tr>
                                <th>N</th>
                                <th>COD</th>
                                <th>DESCRIPCIÓN</th>
                                <th className='whitespace-nowrap'>F. REGISTRO</th>
                                <th className='whitespace-nowrap'>U. REGISTRO</th>
                                <th></th>
                                {/* <th></th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                seguimientosTicket.length > 0 ? 
                                    seguimientosTicket.map((det, i) => (
                                        <tr
                                            key={i + 1 }
                                            style={{background: valoresSeguimiento.indice === i + 1 ? '#19692a' : ''}}
                                        >
                                            <td>{i + 1}</td>
                                            <td><span className='bg-blue-500 px-2 rounded'>{det.codTicketSeguimiento}</span></td>
                                            <td>
                                                <input
                                                    key={'input_'+i}
                                                    className={`${classNameInput} bg-transparent border-none px-2`}
                                                    value={det.descripcion}
                                                    onChange={(e) => editarValorSeguimiento(i,'descripcion',e.target.value)}
                                                    onKeyUp={(e)=> e.keyCode === 13 ? registrarSeguimientoTicket(i) : ''}
                                                    enterKeyHint="enter"
                                                />
                                            </td>
                                            <td className='whitespace-nowrap text-center'>{det.fechaCreacion}</td>
                                            <td className='text-center'>{det.nomUsuarioCreacion}</td>
                                            <td className='text-center'>
                                                <i
                                                    className='fa fa-trash text-red-500'
                                                    onClick={async () => {
                                                        const isValid = await eliminarSeguimiento(det.codTicketSeguimiento)
                                                        if(isValid)
                                                        {
                                                            await listarSeguimientoTicket(valoresSeguimiento.codTicket)
                                                            await listarProyectos(tipoProyecto, startDate, endDate)
                                                        }
                                                    }}
                                                ></i>
                                            </td>
                                        </tr>
                                    )) 
                                : 
                                    (esCrearSeguimiento ? '':
                                        <tr>
                                            <td colSpan={6} className='text-center'>No hay información para mostrar...</td>
                                        </tr>
                                    )
                            }
                            {
                                esCrearSeguimiento ?
                                    <tr style={{background: valoresSeguimiento.indice === 0 ? '#19692a' : ''}} key={'tr_crear'}>
                                        <td colSpan={5} className='p-2'>
                                            <input
                                                className={`${classNameInput} px-2 `}
                                                placeholder='Escribir aquí su seguimiento'
                                                onChange={(e )=> editarValorNuevoSeguimiento('descripcion',e.target.value)}
                                                onKeyUp={(e)=> e.keyCode === 13 ? registrarSeguimientoTicket() : ''}
                                                value={nuevoSeguimientoTicket.descripcion}
                                            />
                                        </td>
                                        <td>
                                            <button
                                                className='bg-blue-500 px-2 rounded'
                                                onClick={() => registrarSeguimientoTicket()}
                                            >
                                                <i className='fa fa-paper-plane'></i>
                                            </button>
                                        </td>
                                    </tr>
                                : ''
                            }
                        </tbody>
                    </table>
                </div>
                <div className={` ${esCrearSeguimiento ? ' hidden ' : ' flex '} justify-end py-2`}>
                    <button
                        className=' rounded-[50%] bg-green-500 px-2 py-1'
                        onClick={()=> {
                            if(!esCrearSeguimiento){
                                editarValorNuevoSeguimiento('descripcion','')
                                editarValorNuevoSeguimiento('codTicket',valoresSeguimiento.codTicket)
                                setEsCrearSeguimiento(true)
                                setValoresSeguimiento({indice: 0, codTicket: valoresSeguimiento.codTicket})
                            }
                        }}
                    >
                        <i className='fa fa-plus'></i>
                    </button>
                </div>
            </Modal>
            
            <Modal
                isOpen={isOpenModalImagen}
                closeModal={closeModalImagen}
                title={'Imágen de análisis'}
                validButton={{confirm: false, denied: true}}
            >
                <div className='w-[500px] gap-2 grid grid-cols-[minmax(0,2fr)_minmax(0,8fr)] items-center'>
                    <span className='lg:text-sm'>Imágenes</span>
                    <ContenedorImagen
                        archivo={analisisImagen}
                        esBloqueo={true}
                        className={'h-[120px] w-full '}
                    />
                    <span className='lg:text-sm '>Documentos</span>
                    <ContenedorDocumento
                        archivo={analisisDoc}
                        esBloqueo={true}
                        className={'h-[120px]'}
                    />
                </div>
            </Modal>
        </>
    )
}